module.exports = __webpack_public_path__ + "static/media/HomeBanner.870b4648.png";